import { render } from "./NoteViewModal.vue?vue&type=template&id=96920cd0&scoped=true"
import script from "./NoteViewModal.vue?vue&type=script&lang=js"
export * from "./NoteViewModal.vue?vue&type=script&lang=js"

import "./NoteViewModal.vue?vue&type=style&index=0&id=96920cd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96920cd0"]])

export default __exports__